module.exports = __webpack_public_path__ + "img/experience_bg.6e791fd4.png";